import { FC } from 'app/FunctionalComponent'
import React from 'react'
import classes from './Comment.module.scss'

export const Comment: FC = (props: { children: React.ReactNode }) => {
	return <div className={classes.comment}>{props.children} </div>
}
